import React, { useState, useEffect } from 'react';
import axios from 'axios';

const token = () => localStorage.getItem('crm_token');
const api = (path, opts = {}) => axios({ url: `/api/wedding-packages${path}`, headers: { Authorization: `Bearer ${token()}` }, ...opts });

const ICONS = {
  food: '🍽️', music: '🎵', decor: '🌸', guests: '👥', price: '💰'
};

const emptyForm = { name: '', description: '', food_menu: '', music_type: '', decor_type: '', extras: '', price_per_person: '', min_guests: '' };

export default function WeddingPackages() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editPkg, setEditPkg] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);

  const fetch = async () => {
    const { data } = await api('/');
    setPackages(data);
    setLoading(false);
  };

  useEffect(() => { fetch(); }, []);

  const openNew = () => { setEditPkg(null); setForm(emptyForm); setShowModal(true); };
  const openEdit = (pkg) => {
    setEditPkg(pkg);
    setForm({
      name: pkg.name, description: pkg.description || '', food_menu: pkg.food_menu || '',
      music_type: pkg.music_type || '', decor_type: pkg.decor_type || '',
      extras: pkg.extras ? JSON.parse(pkg.extras).join(', ') : '',
      price_per_person: pkg.price_per_person, min_guests: pkg.min_guests,
    });
    setShowModal(true);
  };

  const save = async () => {
    if (!form.name) return;
    setSaving(true);
    try {
      const payload = { ...form, extras: form.extras.split(',').map(s => s.trim()).filter(Boolean) };
      if (editPkg) { await api(`/${editPkg.id}`, { method: 'put', data: payload }); }
      else { await api('/', { method: 'post', data: payload }); }
      setShowModal(false);
      fetch();
    } catch (e) { alert(e.response?.data?.error || 'Hata'); }
    finally { setSaving(false); }
  };

  const deactivate = async (id) => {
    if (!window.confirm('Paketi pasife almak istiyor musunuz?')) return;
    await api(`/${id}`, { method: 'delete' });
    fetch();
  };

  if (loading) return <div className="wp-loading">Yükleniyor...</div>;

  return (
    <div className="wp-page">
      <div className="wp-header">
        <div>
          <h1 className="wp-title">📦 Paket Yönetimi</h1>
          <p className="wp-subtitle">Düğün paketlerini tanımlayın ve fiyatlandırın</p>
        </div>
        <button className="wp-btn-primary" onClick={openNew}>+ Yeni Paket</button>
      </div>

      <div className="wp-grid">
        {packages.length === 0 && (
          <div className="wp-empty">
            <div style={{ fontSize: 48 }}>📦</div>
            <p>Henüz paket eklenmemiş</p>
            <button className="wp-btn-primary" onClick={openNew}>İlk Paketi Oluştur</button>
          </div>
        )}
        {packages.map(pkg => {
          const extras = pkg.extras ? (() => { try { return JSON.parse(pkg.extras); } catch { return []; } })() : [];
          return (
            <div key={pkg.id} className="wp-card">
              <div className="wp-card-header">
                <div className="wp-card-icon">💍</div>
                <div>
                  <h3 className="wp-card-name">{pkg.name}</h3>
                  <p className="wp-card-desc">{pkg.description || 'Açıklama yok'}</p>
                </div>
              </div>
              <div className="wp-card-price">
                <span className="wp-price-val">{Number(pkg.price_per_person).toLocaleString('tr-TR')} ₺</span>
                <span className="wp-price-label">/ kişi</span>
              </div>
              <div className="wp-card-details">
                {pkg.food_menu && <div className="wp-detail-row">{ICONS.food} <span>{pkg.food_menu}</span></div>}
                {pkg.music_type && <div className="wp-detail-row">{ICONS.music} <span>{pkg.music_type}</span></div>}
                {pkg.decor_type && <div className="wp-detail-row">{ICONS.decor} <span>{pkg.decor_type}</span></div>}
                {pkg.min_guests > 0 && <div className="wp-detail-row">{ICONS.guests} <span>Min. {pkg.min_guests} kişi</span></div>}
              </div>
              {extras.length > 0 && (
                <div className="wp-extras">
                  {extras.map((ex, i) => <span key={i} className="wp-extra-tag">{ex}</span>)}
                </div>
              )}
              <div className="wp-card-actions">
                <button className="wp-btn-edit" onClick={() => openEdit(pkg)}>Düzenle</button>
                <button className="wp-btn-del" onClick={() => deactivate(pkg.id)}>Pasife Al</button>
              </div>
            </div>
          );
        })}
      </div>

      {showModal && (
        <div className="wp-overlay" onClick={() => setShowModal(false)}>
          <div className="wp-modal" onClick={e => e.stopPropagation()}>
            <div className="wp-modal-header">
              <h2>{editPkg ? 'Paketi Düzenle' : 'Yeni Paket'}</h2>
              <button onClick={() => setShowModal(false)} className="wp-close">✕</button>
            </div>
            <div className="wp-modal-body">
              <div className="wp-form-grid">
                <div className="wp-field wp-field-full">
                  <label>Paket Adı *</label>
                  <input placeholder="Örn: Altın Paket" value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
                </div>
                <div className="wp-field wp-field-full">
                  <label>Açıklama</label>
                  <textarea rows={2} placeholder="Paket açıklaması..." value={form.description} onChange={e => setForm({...form, description: e.target.value})} />
                </div>
                <div className="wp-field">
                  <label>{ICONS.food} Yemek Menüsü</label>
                  <input placeholder="Örn: 5 çeşit meze, ana yemek..." value={form.food_menu} onChange={e => setForm({...form, food_menu: e.target.value})} />
                </div>
                <div className="wp-field">
                  <label>{ICONS.music} Müzik Tipi</label>
                  <input placeholder="Örn: DJ + Canlı Müzik" value={form.music_type} onChange={e => setForm({...form, music_type: e.target.value})} />
                </div>
                <div className="wp-field">
                  <label>{ICONS.decor} Dekor Tipi</label>
                  <input placeholder="Örn: Çiçek masası + Led" value={form.decor_type} onChange={e => setForm({...form, decor_type: e.target.value})} />
                </div>
                <div className="wp-field">
                  <label>{ICONS.guests} Min. Misafir</label>
                  <input type="number" placeholder="0" value={form.min_guests} onChange={e => setForm({...form, min_guests: e.target.value})} />
                </div>
                <div className="wp-field">
                  <label>{ICONS.price} Kişi Başı Fiyat (₺) *</label>
                  <input type="number" placeholder="0.00" value={form.price_per_person} onChange={e => setForm({...form, price_per_person: e.target.value})} />
                </div>
                <div className="wp-field">
                  <label>Ekstralar (virgülle ayırın)</label>
                  <input placeholder="Pasta, Fotoğrafçı, Davetiye..." value={form.extras} onChange={e => setForm({...form, extras: e.target.value})} />
                </div>
              </div>
            </div>
            <div className="wp-modal-footer">
              <button className="wp-btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
              <button className="wp-btn-primary" onClick={save} disabled={saving}>{saving ? 'Kaydediliyor...' : 'Kaydet'}</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .wp-loading { display:flex; align-items:center; justify-content:center; height:300px; color:#9CA3AF; }
        .wp-page { padding:24px; max-width:1400px; }
        .wp-header { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:24px; flex-wrap:wrap; gap:12px; }
        .wp-title { font-size:24px; font-weight:700; color:#FFFFFF; margin:0; }
        .wp-subtitle { font-size:14px; color:#9CA3AF; margin:4px 0 0; }
        .wp-btn-primary { background:linear-gradient(135deg,#3B82F6,#2563EB); color:#fff; border:none; padding:10px 20px; border-radius:10px; font-weight:600; cursor:pointer; font-size:14px; box-shadow:0 4px 12px rgba(59,130,246,0.3); transition:all 0.2s; }
        .wp-btn-primary:hover { transform:translateY(-1px); box-shadow:0 6px 16px rgba(59,130,246,0.4); }
        .wp-btn-primary:disabled { opacity:0.6; cursor:not-allowed; transform:none; }
        .wp-btn-secondary { background:rgba(255,255,255,0.06); color:#E5E7EB; border:1px solid rgba(255,255,255,0.1); padding:10px 20px; border-radius:10px; font-weight:600; cursor:pointer; }
        .wp-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(320px,1fr)); gap:20px; }
        .wp-empty { grid-column:1/-1; text-align:center; padding:60px; color:#6B7280; display:flex; flex-direction:column; align-items:center; gap:12px; background:rgba(17,17,24,0.7); border:1px solid rgba(255,255,255,0.06); border-radius:16px; }
        .wp-card { background:rgba(17,17,24,0.7); border:1px solid rgba(255,255,255,0.06); border-radius:16px; padding:24px; display:flex; flex-direction:column; gap:16px; transition:all 0.2s; backdrop-filter:blur(12px); }
        .wp-card:hover { border-color:rgba(59,130,246,0.3); box-shadow:0 8px 24px rgba(0,0,0,0.3); transform:translateY(-2px); }
        .wp-card-header { display:flex; gap:14px; align-items:flex-start; }
        .wp-card-icon { font-size:32px; width:48px; height:48px; display:flex; align-items:center; justify-content:center; background:rgba(59,130,246,0.12); border-radius:12px; flex-shrink:0; }
        .wp-card-name { font-size:17px; font-weight:700; color:#FFFFFF; margin:0 0 4px; }
        .wp-card-desc { font-size:13px; color:#9CA3AF; margin:0; }
        .wp-card-price { display:flex; align-items:baseline; gap:4px; }
        .wp-price-val { font-size:28px; font-weight:800; color:#60A5FA; }
        .wp-price-label { font-size:13px; color:#6B7280; }
        .wp-card-details { display:flex; flex-direction:column; gap:6px; }
        .wp-detail-row { display:flex; gap:8px; font-size:13px; color:#9CA3AF; }
        .wp-extras { display:flex; flex-wrap:wrap; gap:6px; }
        .wp-extra-tag { background:rgba(59,130,246,0.12); color:#60A5FA; border:1px solid rgba(59,130,246,0.2); padding:3px 10px; border-radius:20px; font-size:12px; font-weight:500; }
        .wp-card-actions { display:flex; gap:8px; margin-top:auto; }
        .wp-btn-edit { flex:1; padding:8px; border:1px solid rgba(59,130,246,0.3); background:rgba(59,130,246,0.1); color:#60A5FA; border-radius:8px; font-weight:600; cursor:pointer; font-size:13px; }
        .wp-btn-del { flex:1; padding:8px; border:1px solid rgba(239,68,68,0.2); background:rgba(239,68,68,0.05); color:#FCA5A5; border-radius:8px; font-weight:600; cursor:pointer; font-size:13px; }
        .wp-overlay { position:fixed; inset:0; background:rgba(0,0,0,0.75); backdrop-filter:blur(8px); display:flex; align-items:center; justify-content:center; z-index:1000; padding:16px; }
        .wp-modal { background:rgba(17,17,24,0.95); border:1px solid rgba(255,255,255,0.1); border-radius:20px; width:100%; max-width:600px; max-height:90vh; display:flex; flex-direction:column; box-shadow:0 24px 48px rgba(0,0,0,0.6); backdrop-filter:blur(40px); }
        .wp-modal-header { display:flex; align-items:center; justify-content:space-between; padding:20px 24px; border-bottom:1px solid rgba(255,255,255,0.06); }
        .wp-modal-header h2 { margin:0; font-size:18px; font-weight:700; color:#FFFFFF; }
        .wp-close { background:rgba(255,255,255,0.06); border:none; font-size:18px; color:#9CA3AF; cursor:pointer; width:32px; height:32px; display:flex; align-items:center; justify-content:center; border-radius:8px; }
        .wp-modal-body { padding:24px; overflow-y:auto; flex:1; }
        .wp-modal-footer { display:flex; justify-content:flex-end; gap:10px; padding:16px 24px; border-top:1px solid rgba(255,255,255,0.06); }
        .wp-form-grid { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
        .wp-field { display:flex; flex-direction:column; gap:6px; }
        .wp-field-full { grid-column:1/-1; }
        .wp-field label { font-size:13px; font-weight:600; color:#E5E7EB; }
        .wp-field input, .wp-field textarea { padding:10px 12px; border:1px solid rgba(255,255,255,0.08); border-radius:10px; font-size:14px; outline:none; background:rgba(26,26,36,0.8); color:#FFFFFF; }
        .wp-field input:focus, .wp-field textarea:focus { border-color:#3B82F6; box-shadow:0 0 0 3px rgba(59,130,246,0.1); }
      `}</style>
    </div>
  );
}
